
import { defineComponent, computed, PropType } from 'vue'
import { Campaigns } from '@/lib/campaigns'

import { Campaign, Variant } from '@/types'
import { Selection } from '@/types/order'
import { formatPrice, formatDate, ItemColorFormatter, useItemColorFormatter } from '@/lib/formatters'

interface LineItem {
  variant: Variant;
  sizeName: string;
  priceWithTax: number;
  quantity: number;
  thumbnailUrl: string;
}

export default defineComponent({
  props: {
    campaign: {
      type: Object as PropType<Campaign>,
      required: true
    },
    selections: {
      type: Array as PropType<Selection[]>,
      default: []
    }
  },
  setup (props) {
    const variantFromId = (variantId: number) => {
      return Campaigns.variant(props.campaign, variantId)
    }

    const sizeName = (sizeId: number): string => {
      const size = props.campaign.item.sizes.find(s => s.id === sizeId)
      return size ? size.name : ''
    }

    const variantThumbnail = (variant: Variant): string => {
      const thumbnail = variant.prints[0].thumbnailUrls.find(u => u.size === 'small')
      return thumbnail ? thumbnail.url : ''
    }

    const selectionToLineItem = (selection: Selection): LineItem | null => {
      const { variantId, itemSizeId, quantity } = selection
      const variant = variantFromId(variantId)

      if (variant) {
        return {
          variant,
          sizeName: sizeName(itemSizeId),
          priceWithTax: variant.priceWithTax,
          quantity: quantity,
          thumbnailUrl: variantThumbnail(variant)
        }
      } else {
        return null
      }
    }

    const lineItems = computed<LineItem[]>(() => {
      return props.selections
        .map((selection) => selectionToLineItem(selection))
        .filter(lineItem => !!lineItem) as LineItem[]
    })

    return { lineItems, formatPrice, formatDate }
  },
  computed: {
    itemColorFormatter (): ItemColorFormatter {
      return useItemColorFormatter()
    }
  },
  methods: {
    formatItemColor (variant: Variant) {
      return this.itemColorFormatter(variant)
    }
  }
})
